var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfilePersona = function SvgProfilePersona(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DEE2E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.762 11.762a4.747 4.747 0 0 1-4.764 4.763 4.747 4.747 0 0 1-4.765-4.763A4.747 4.747 0 0 1 15.998 7a4.746 4.746 0 0 1 4.764 4.762ZM16 25c-3.904 0-7.2-.634-7.2-3.083 0-2.449 3.317-3.06 7.2-3.06 3.905 0 7.2.634 7.2 3.082C23.2 24.388 19.883 25 16 25Z",
    fill: "#495057"
  })));
};
export default SvgProfilePersona;